<template>
  <div>
    <span v-if="data.length === 0" class="height d_flex"><b>No data to display</b></span>
    <div  v-else>
      <div class="float_right" v-if="filters.length>0">
        <select id="select_media" v-model="selectedFilter">
            <option v-for="filter in filters"> {{filter}}</option>
        </select>
      </div>
      <div v-else><br/></div>
      <highcharts class="height" :options="options.chart" ref="chart"/>
    </div>
  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'
export default {
  components: {
    highCharts: Chart,
  },

  data() {
    return {
      selectedFilter: this.filters.length>0 ? this.filters[0] : "",
      options: {
        stats: {},
        chart: {
          chart: {
            type: 'line',
          },
          title: {
            text: this.title
          },
          xAxis: {
            categories: this.categories,
          },
          yAxis: {
            title: {
              text: this.sideText
            }
          },
          plotOptions: {
            series: {
              label: {
                connectorAllowed: false
              }
            }
          },
          series: this.data,
          responsive: {
            rules: [{
              condition: {
                maxWidth: 500, // Adjust the maximum width as needed
                maxHeight: 300 // Adjust the maximum height as needed
              },
              chartOptions: {
                legend: {
                  layout: 'horizontal',
                  align: 'center',
                  verticalAlign: 'bottom'
                }
              }
            }]
          },
          chartHeight: 200
        }
      },
    };
  },

  props: {
    data: Array,
    filters: {
      type: Array,
      default: () => []
    },
    defaultFilter: {
      type: Boolean,
      default: () => false,
    },
    categories: Array,
    sideText: String,
    bottomText: String,
    title: String,
    type: String,
    color: String,
  },

  watch: {
    data: {
      handler(val) {
        this.options.chart.series = val
      },
      deep: true,
      immediate: true
    },
    categories: {
      handler(val) {
        this.options.chart.xAxis.categories = val
      },
      deep: true,
      immediate: true
    },
    selectedFilter(newVal) {
      this.$emit('input', newVal);
    },
    defaultFilter: {
      handler(newVal) {
        if (newVal) {
          this.selectedFilter = this.filters[0]
        }
      },
    }
  }
};
</script>

<style scoped>
.height {
  height: 100%;
  width: 100%;
}

.d_flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.float_right {
  float: right;
}
</style>
